/* export
  - menuIdRouteMappings
  - menuIdNameMappingsFromBundle
*/;
export * from 'sce-core/constants';
// #TODO-LIBRARY constants->menuIdRouteMappings Used in 13 places 13 files in WMS /src/app.. should be re-referenced from library directly


export const STATUS = {
  SUCCESS: 'SUCCESS',
};

export const YES = 'YES';
export const HAS_RIGHTS = 'Y';

export const DISPLAY_MODE = {
  EDIT: 'E',
  CREATE: 'C',
  VIEW: 'V'
};

export const PMM_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const META_DATA = {
  DROPDOWN: 'DROPDOWN',
  EDITABLEDROPDOWN: 'EDITABLEDROPDOWN',
  REC_TYPE: 'recType',
  DOC_STATUS: 'docStatus',
  ASN_REASON: 'asnRetReason',
  ADJUSTMENT_TYPE: 'adjustmentType',
  ID: 'id',
  DESCR: 'descr',
  REMARK: 'remark',
  LOC: 'loc',
  PALLET_TYPE: 'PalletType',
  FINALIZE_STAGE: 'finalizeStage',
  STOCK_TAKE_KEY: 'stockTakeKey',
  STATUS: 'status',
  TRANS_METHOD: 'transMethod',
  CCDETAIL_KEY: 'CCDETAILKey'
};

export const TABLE_ID = {
  TRTD: 'trtd',
  SHIPREFTD: 'shipreftd',
  ASNTD: 'asntd',
};

export const SEARCH_OPERATORS = {
  EQUAL: '=',
  AND: 'AND',
  OR: 'OR',
  EDIT_MODE: 'EDIT',
  IN: 'in',
};

export const COMMON_FIELDS = {
  FACILITY: 'facility',
  STORER_KEY: 'storerKey',
  SKU: 'sku',
  RECEIPT_KEY: 'receiptKey',
  STATUS: 'status',
  ASN_NUMBER: 'asnNumber',
};

export const INVENTORY_BALANCE_CONSTANTS = {
  TABLE_ID: 'invlotlocidtd',
  ROUTE_REGEX: /\/inventorybalance\/(\d+)$/,
  MOVABLE_UNIT_ID: 'id',
  FACILITY: "facility",
  STORER_KEY: "storerKey"
};
export const HyperlinkTemplateId = {
  TRANSFER_TICKET_LINK: 9,
  MOVABLE_UNIT_LINK: 10,
};
export const LOOKUP_CONSTANTS = {
  TABLE_ID: 'storertd',
  ID_PROPERTY: 'storerName',
  COLUMN_COUNT: 10
};
export const PACK_MNGT_CONSTANTS = {
  IS_EDITABLE: 'isEditable',
  STORER_KEY: "storerKey",
  STATUS: "status",
  ORDER_KEY: "orderKey",
};

export const ALLOCATION_STATUS = {
  SCHEDULED: '0',      // Awaiting allocation (Scheduled Job)
  IN_PROGRESS: '1',    // Allocation in progress
  PICKED: 5,         // Allocated/Picked
};
export const CASE_ID_CONFIG_KEY = 'SCEDontAllowEditPickCASEID';
export const UNALLOCATE_ACTION_EVENT = 'unallocate';

export const TABLE_NAMES = {
  MBOL: 'MBOL',
  INVENTORY_MOVE_TABLE: 'invmovetd',
  UCC_ADJUSTMENT_DETAIL_TABLE: 'uccadjdtltd',
  POPULATE_TRANSFER_UCC: 'populatefrmucctd',
  ORDER_DETAIL: 'ORDERDETAIL',
  STOCK_TAKE_PARAM_DET: 'STKPARTD',
  MBOL_ERROR_LOG : 'ddmbolerrortd',
  CBOL : 'ddcboltd',
  MBOL_DETAIL : 'ddmboldetailtd',
  CONSIGNEE_SKU: 'CONSIGNEESKUTD',
  PICK_TD: 'picktd',
  UCC_MAIN: 'uccmaintd',
  COUNT_SHEET_3: 'stkcnt3td',
  CYCLE_COUNT: (countNumber: number) => `stkcnt${countNumber}td`
};
export const CONSTANTS_VALUE = {
   ALL_VALUES: "*"
}
export const RESPONSE_BODY_VALUE = {
  PROCEED_WITH_WARNING: "N",
  WARNING_NO: "0"
}
export const COLUMN_NAMES = {
  TO_QTY: 'toQty',
  UCC : 'UCC',
  TRANSFER_KEY: 'transferKey',
  LOT: 'lot'
}
export const TYPE_PROPERTY: string = 'TRANHOLD';
export const CHANNEL_INVENTORY_CONSTANTS = {
  HOLD_TYPE: 'holdType',
  CHANNEL: 'Channel',
  CHANNEL_ID: 'channel_id',
  FACILITY: 'facility',
  STORER_KEY: 'Storerkey',
  SKU: 'sku'
};

export const POPULATE_TYPES = {
  'POPULATE' : 'populate',
  'POPULATE_UCC': 'Populate',
  'POPULATE_ALL_UCC' : 'PopulateAll_UCC',
  'POPULATE_ALL' : 'populateAll'
}
export const LOTTABLE_FIELDS = [
  'lottable01', 'lottable02', 'lottable03', 'lottable04', 'lottable05',
  'lottable06', 'lottable07', 'lottable08', 'lottable09', 'lottable10',
  'lottable11', 'lottable12', 'lottable13', 'lottable14', 'lottable15'
]
export const ROWS_WITH_LOTTABLE_FIELDS = [1, 2];
export const CHANNEL_TRANSFER_CONSTANTS = {
  'SEARCH': 'search',
  'DETAILS': 'details',
  'FROMSTORER': 'fromStorerKey'
};
export const WAVE_CONTROL_CONSTANTS = {
  STORER: 'storerKey',
  DEFAULT_STORER: 'defaultStorer'
}
export const FIELD_TYPES = {
  DROPDOWN: 'DROPDOWN',
  EDITABLE_DROPDOWN: 'EDITABLEDROPDOWN',
}
export const TRANSFER_CONSTANTS = {
  FROM_FACILITY: 'fromFacility',
  TO_FACILITY: 'toFacility',
}
export const FACILITY_FIELDS = ['facility', 'fromFacility', 'toFacility'];

export const PICK_MNGT_CONSTANTS = {
  ORDER_LINE_NO : 'orderLineNo',
  ORDER_LINE_NUMBER : 'orderLineNumber',
  LOOK_UP_LENGTH : 5,
  ORDER_TABLE_TD : 'orderlinenotd',
  ORDER_KEY : 'orderKey',
  COMMODITY : 'commodity',
  PACK_KEY : 'packKey',
  LOTTABLE_01 : 'lottable01',
  LOTTABLE_02 : 'lottable02',
  LOTTABLE_03 : 'lottable03',
  LOTTABLE_04 : 'lottable04',
  LOTTABLE_05 : 'lottable05',
  LOTTABLE_06 : 'lottable06',
  LOTTABLE_07 : 'lottable07',
  LOTTABLE_08 : 'lottable08',
  LOTTABLE_09 : 'lottable09',
  LOTTABLE_10 : 'lottable10',
  LOTTABLE_11 : 'lottable11',
  LOTTABLE_12 : 'lottable12',
  LOTTABLE_13 : 'lottable13',
  LOTTABLE_14 : 'lottable14',
  LOTTABLE_15 : 'lottable15'
}

export const WAVECONTROL_CONSTANTS = {
  ORDER_KEY : 'orderKey',
  SO:'so',
  CARRIER_AGENT:'carrieragent',
}

export const MESSAGES = {
  RECEIVED_QTY: 'lbl_rec_qty',
  CONFIRM_ASN_FINALIZE: 'msg_conf_fin',
  CONFIRM_ASN_CLOSE: 'msg_conf_cls_asn'
};

export const PRIMARY_FIELDS_TO_PROPAGATE = [
  'allocateStrategyKey',
  ' appntStrtgyKey',
  'doorBkingStrtgyKey',
  'preallocateStrategyKey',
  'putawayStrategyKey',
  'replenishStrategyKey',
  'ttmStrategyKey',
  'xdockStrategyKey',
  'holidayKey',
  'pmKey',
]

export const PALLET_MAINTENANCE_STATUS = {
  OPEN: '0',
  TRANSFERRING: '3',
  FINALIZED: '9',
}

export const CBOL_CONSTANTS = {
  STATUS_NORMAL : '0',
  STATUS_SHIPPED : '9',
  SUCCESS_CODE: 1,
  FAILURE_CODE: 0
}

/* Dock Door Booking Constants */
export const DDB_CONSTANTS = {
  INBOUND_TD: 'ddbookintd',
  OUTBOUND_TD: 'ddbooktd',
  SCHEDULE_BY_DAY_TD: 'ddschedulebydaytd',
  SCHEDULE_BY_DOOR_TD: 'ddschedulebydoortd',
  BAY_IN : 'BAYIN',
  BAY_OUT : 'BAYOUT',
  OUTBOUND : 'OUTBOUND',
  INBOUND : 'INBOUND',
  INBOUND_EVENT: 'inboundBook',
  OUTBOUND_EVENT: 'outboundBook',
  BLOCK_EVENT : 'block',
  REFRESH_EVENT: 'refresh'
}
export const SEARCH_KEYS = {
  ALL: '*',
  STORER: 'storerKey',
  STORER_NAME: 'storerName',
  CONSIGNEE_NAME: 'consigneeName',
  CONSIGNEE_KEY: 'consigneeKey',
  FACILITY: 'facility',
  LOC_ID: 'locId',
  SKU: 'sku',
  LOT: 'lot',
  CASE_ID: 'caseID',
  CASEID_POPUP: 'caseid',
  LOAD_KEY: 'loadKey',
  LOAD: 'load'
}

export const POPUP_EVENT_TYPE = {
  HIDE: 'hide',
}

export const POPUP_CONFIG = {
  OVERLAY_WIDTH: 1024,
  OVERLAY_HEIGHT: 520,
}

export const LENGTH_VALUE = {
  ONE: 1
};
export const DEFAULT_SELECT_OPTION = {
  key: '', value: '- Select -', storerkey: null, userDefineValues: null
};

export const FIELD_NAMES = {
  CASE_CNT: 'CaseCnt',
  STATUS: 'Status',
  FINALIZE_FLAG: 'FinalizeFlag',
  STATUS_FINALIZED: '9',
  STATUS_PARTIALLY_ALLOCATED: '1',
  FINALIZE_FLAG_CNT2: 'FinalizeFlag_Cnt2',
  FINALIZE_FLAG_CNT3: 'FinalizeFlag_Cnt3',
};

export const ABC_MANAGEMENT = {
  TOTAL_PICKS_TABLE: 'total-picks-table',
  PIECE_PICKS_TABLE: 'piece-picks-table',
  CASE_PICKS_TABLE: 'case-picks-table',
  BULK_PICKS_TABLE: 'bulk-picks-table'
};

export const STORER_CONFIG_KEYS = {
  STOCK_TAKE_FINALIZE: 'StockTakeFinalizeByCountSheet'
};

export const ROW_ADDITION_BUTTONS = ['Insert', 'Add Row'];


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/constants.ts